
import { useEffect } from 'react';
import { globals, logger } from 'common-ui';
import { useRecoilValue } from 'recoil';
import { selectUserDetails } from 'common-state';
import aa from 'search-insights';
declare global {
  interface Window {
    OptanonWrapper?: () => void;
    OnetrustActiveGroups?: string; // Comma-separated string of active group codes
  }
}

// Helper function to delete a cookie
export function deleteCookie(name: string): void {
  // Set the cookie with an expired date to delete it
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

// Helper function defined outside to avoid recreation
export function handleConsent(oneTrustCookieConsentCategory: string, brandAccountNumber?: string): void {
  const { OnetrustActiveGroups } = window;

  const activeGroups = OnetrustActiveGroups
    ? OnetrustActiveGroups.split(',').map((g) => g.trim())
    : [];


  if (activeGroups.includes(oneTrustCookieConsentCategory)) {
    logger.info('Algolia Cookie Set');
    aa('init', {
      partial: true,
      useCookie: true,
    });
    if (brandAccountNumber) {
      aa('setAuthenticatedUserToken', brandAccountNumber);
    }
  } else {
    logger.info('Algolia Cookie Not Set');
    aa('init', {
      partial: true,
      useCookie: false,
    });
    // Optionally clean up cookies if needed
    deleteCookie('_ALGOLIA');
  }
}

// Retry logic to wait for OneTrust consent categories
function waitForConsentAndHandle(callback: () => void): void {
  const interval = setInterval(() => {
    if (window.OnetrustActiveGroups !== undefined) {
      clearInterval(interval);
      callback();
    }
  }, 200);

  // Stop checking after 5 seconds
  setTimeout(() => clearInterval(interval), 5000);
}

/**
 * Custom hook that sets the authenticated user token for Algolia.
 * It listens for updates in cookie consent categories and sets the token accordingly.
 */
export const useAlgoliaInit = (): void => {
  const oneTrustCookieConsentCategory = '2'; // Ensure this matches your OneTrust setup
  const userDetails = useRecoilValue(selectUserDetails);
  const brandAccountNumber = userDetails?.brandAccountNumber;

  const baseConfig = {
    appId: globals.algoliaAppId,
    apiKey: globals.algoliaSearchKey,
  };



  useEffect(() => {

    aa('init', {
      ...baseConfig,
    });

    logger.info('Algolia initialized with base config:', baseConfig);

    // We set useCookie to true for US and APAC users
    if (globals.country !== 'uk') {
      return aa('init', {
        partial: true,
        useCookie: true,
      });
    }

    window.OptanonWrapper = function () {
      handleConsent(oneTrustCookieConsentCategory, brandAccountNumber);
    };

    // Call once on mount *after* OneTrust groups are ready
    waitForConsentAndHandle(() => {
      window.OptanonWrapper?.();
    });

    return () => {
      window.OptanonWrapper = undefined;
    };
  }, [oneTrustCookieConsentCategory, brandAccountNumber]);
};
